export const userQueryTypeMap = {
    current: 'Boolean',
    id: 'ID',
    is_blocked: 'Boolean',
    reset_token: 'String',
    email: 'String',
};

export const tarifsQueryTypeMap = {
    id: 'ID',
    lookup_key: 'String',
    is_active: 'Boolean',
    is_subscribable: 'Boolean',
    validity_months: 'NumberComparisonInput',
    maxLeadsCount: 'NumberComparisonInput',
    price: 'NumberComparisonInput',
    required_feature_values: '[TariffFeatureRequirementInput!]',
    campaign_key: 'String',
};

export const quizzesQueryTypeMap = {
    id: 'ID',
    user_id: 'ID',
    code: 'String',
    domain: 'String',
    project_id: 'ID',
    lang: 'String',
    is_template: 'Boolean',
    is_deleted: 'Boolean',
    tags: '[String]',
    limit: 'Int',
    page: 'Int',
    include_shared: 'Boolean'
};

export const updateUserTypeMap = {
    id: 'ID!',
    password: 'String',
    name: 'String',
    phone: 'String',
    interface_lang: 'String',
    profile: 'String',
    uploaded_avatar: 'String',
    is_blocked: 'Boolean',
    timezone: 'Float',
    // learning_center: 'JSON',
};

export const quizCollaboratorsQueryTypeMap = {
    quiz_id: 'ID!',
    limit: 'Int',
    page: 'Int',
    only_active: 'Boolean',
};

export const updateQuizTypeMap = {
    id: 'ID!',
    name: 'String',
    domain: 'String',
    project_id: 'ID',
    timezone: 'Int',
    contacts: 'String',
    is_template: 'Boolean',
    tags: '[String]',
    embed_domains: '[String]',
    logotype_id: 'ID',
    logotype: 'String',
};

export const updateQuizOptionsTypeMap = {
    show_progress: 'Boolean',
    id: 'ID!',
    lang: 'String',
    hide_label: 'Boolean',
    show_back_button: 'Boolean',
    spam_filter: 'SpamFilterInput',
    custom_privacy_policy_url: 'String',
    qr_code: 'UTMInput',
    corners: 'String',
    theme: 'String',
    auto_next: 'Boolean',
    auto_redirect: 'Boolean',
    auto_redirect_url: 'String',
    custom_design: 'String',
    animation: 'String',
    privacy_policy_request: 'Boolean',
    points: 'PointsInput',
    benefits: 'QuizOptionsBenefitsInput',
};

export const quizIdMutationTypeMap = {
    id: 'ID!',
};

export const shareQuizTypeMap = {
    quiz_id: 'ID!',
    email: 'String',
    user_email: 'String',
    permissions: 'QuizCollaboratorPermissionsInput',
    can_manage_quiz: 'Boolean',
    can_copy: 'Boolean',
    can_manage_integrations: 'Boolean',
    can_view_crm: 'Boolean',
    can_share: 'Boolean',
    can_transfer: 'Boolean',
    can_delete: 'Boolean',
    can_publish: 'Boolean',
    expires_at: 'String',
};

export const quizAccessTypeMap = {
    id: 'ID!',
    status: 'String',
};

export const leadsQueryTypeMap = {
    id: 'ID',
    UUID: 'String',
    quiz_id: 'ID',
    limit: 'Int',
    page: 'Int',
};

export const bonusesQueryTypeMap = {
    id: 'ID',
    user_id: 'ID',
};

export const integrationTypesQueryTypeMap = {
    class: 'String',
    group: 'String',
};

export const projectsQueryTypeMap = {
    id: 'ID',
    user_id: 'ID',
};

export const projectMutationTypeMap = {
    id: 'ID!',
    name: 'String',
    emoji: 'String',
};

export const integrationMutationTypeMap = {
    id: 'ID!',
    quiz_id: 'ID!',
    type_id: 'ID!',
    active: 'Boolean!',
    data: 'JSON!',
    sort: 'Int',
};

export const testIntegrationTypeMap = {
    lead_id: 'ID!',
    integration_id: 'ID!',
};

export const unlinkOauthAccountTypeMap = {
    provider: 'String!',
    scopes: '[String]',
};

export const questionsQueryTypeMap = {
    domain: 'String',
    quiz_code: 'String',
    hidden: 'Boolean',
};
